import React from 'react';
import './PC.css';
import Abbas from '../../img/pc/Abbas.png'
import Arshad from '../../img/pc/Arshad.png'
import BlueFire from '../../img/pc/BlueFire.png'
import DevAngels from '../../img/pc/DevAngels.png'
import ElectronicArts from '../../img/pc/ElectronicArts.png'
import FlutterExplained from '../../img/pc/FlutterExplained.png'
import Klingsbo from '../../img/pc/Klingsbo.png'
import Leushchenko from '../../img/pc/Leushchenko.png'
import Lidholt from '../../img/pc/Lidholt.png'
import PicnicInc from '../../img/pc/PicnicInc.png'
import reactree from '../../img/pc/reactree.png'
import Serverpod from '../../img/pc/Serverpod.png'
import Stoll from '../../img/pc/Stoll.png'
import Tide from '../../img/pc/Tide.png'
import Weber from '../../img/pc/Weber.png'
import Wu from '../../img/pc/Wu.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Weber,
          name: 'Max Weber',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/max-weber-9889a3ba/',
          tw: 'https://twitter.com/flutter_exp',
          github: 'https://github.com/md-weber',
          logo: FlutterExplained,
        },
        {
          photo: Klingsbo,
          name: 'Lukas Klingsbo',
          position: 'Senior Developer',
          tw: 'https://twitter.com/spydon',
          logo: BlueFire,
        },
        {
          photo: Lidholt,
          name: 'Viktor Lidholt',
          position: 'Founder & Lead Developer',
          ln: 'https://www.linkedin.com/in/viktorlidholt/',
          logo: Serverpod,
        },
        {
          photo: Leushchenko,
          name: 'Anna Leushchenko',
          position: 'Senior Staff Mobile Engineer',
          tw: 'https://twitter.com/AnnaLeushchenko',
          github: 'https://github.com/foxanna',
          website: 'https://medium.com/@foxanna',
          logo: Tide,
        },
        {
          photo: Arshad,
          name: 'Waleed Arshad',
          position: 'Flutter Engineer',
          ln: 'https://www.linkedin.com/in/waleed006/',
          tw: 'https://twitter.com/wal_33d',
          github: 'https://github.com/wal33d006',
          logo: PicnicInc,
        },
        {
          photo: Stoll,
          name: 'Scott Stoll',
          position: 'Flutter Developer',
          ln: 'https://www.linkedin.com/in/scott-stoll-59722915a/',
          logo: DevAngels,
        },
        {
          photo: Wu,
          name: 'Teresa Wu',
          position: 'VP of Software Engineer',
          ln: 'https://www.linkedin.com/in/yayiwu/',
          tw: 'https://twitter.com/teresa_wyy',
          logo: ElectronicArts,
        },
        {
          photo: Abbas,
          name: 'Sakina Abbas',
          position: 'Co-Founder & CEO',
          ln: 'https://pk.linkedin.com/in/sakina-abbas',
          tw: 'https://twitter.com/sakin8tor',
          logo: reactree,
        },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}